import headerClasses from 'Features/MainSale/Components/MainSaleHeader/auction-header.module.scss';
import React, { ReactElement } from 'react';

interface IEvBatteryHealthProps {
    score?: number;
    certificateUrl?: string;
    gradeElement?: ReactElement | null;
    layout?: 'vertical' | 'horizontal';
}

const EvBatteryHealth: React.FC<IEvBatteryHealthProps> = ({
    score,
    certificateUrl,
    gradeElement = null,
    layout = 'vertical'
}) => {
    if (!score) {
        return <>{gradeElement}</>;
    }

    const roundedScore = Math.round(score);
    const containerClass = layout === 'horizontal'
        ? headerClasses['grade-with-battery-inline']
        : headerClasses['grade-with-battery'];

    return (
        <div className={containerClass}>
            {gradeElement && <div>{gradeElement}</div>}
            <a
                href={certificateUrl}
                target="_blank"
                rel="noopener noreferrer"
                title={`EV Battery Health: ${roundedScore}%`}
                className={headerClasses['ev-battery-icon']}
            >
                <span className={headerClasses['ev-battery-label']}>{roundedScore}%</span>
            </a>
        </div>
    );
};

export default EvBatteryHealth;